import React from 'react';
import { Button } from '@cad-arc';
import { AttachmentDto } from '@mark43/cad-api';
import { useDownloadAttachment } from './hooks/use-download-attachment';
import { observer } from 'mobx-react-lite';
import { getDownloadUrl, getFileName, getFileSize } from './helpers';

export interface AttachmentDownloadButtonProps {
    attachment: AttachmentDto;
}

export const AttachmentDownloadButton = observer(function AttachmentDownloadButton({
    attachment,
}: AttachmentDownloadButtonProps): React.ReactElement {
    const fileName = getFileName(attachment);
    const fileUrl = getDownloadUrl(attachment);
    const fileSize = getFileSize(attachment);
    const { downloadAttachment, isDownloading, progress } = useDownloadAttachment({
        attachmentId: attachment.attachmentId,
        fileName,
        fileUrl,
        fileSize,
    });

    return (
        <Button variant="outline" onClick={downloadAttachment} flex={1} isDisabled={isDownloading}>
            {progress !== undefined ? `${progress}%` : 'Download'}
        </Button>
    );
});
